import React, { MouseEventHandler } from 'react';
import classNames from 'classnames';
import { TabsRole } from './const';
import classes from './styles/tabList.module.scss';
import { TabComponent } from './types';
import { useTabsWrapperProvider } from './Tabs';

type TabListProps = {
	className?: string;
	dataTestId?: string;
};

/**
 * Wrapper for Tab components
 * Handles click event
 */
export const TabList: TabComponent<TabListProps> = ({ className, dataTestId, children }) => {
	const componentClasses = classNames(classes.tabList, className);

	const { onTabChange } = useTabsWrapperProvider();

	const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
		const target = e.target as HTMLDivElement;
		const tab = target.closest('button[role="tab"]');

		if (tab) {
			const id = tab.id.split('-')[1];

			onTabChange(id);
		}
	};

	return (
		<div
			className={componentClasses}
			role='tablist'
			onClick={handleClick}
			data-testid={dataTestId}
		>
			{children}
		</div>
	);
};

TabList.tabsRole = TabsRole.TabList;
